import React from "react";
import * as actions from '../actions';
import Service from '../../../service/Service';
const service = new Service();

export default function FooterMenu({ eleRef, flag, recipes, isApp}) {
    if (__isBrowser__) {
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                if(isApp) {
                    document.getElementsByClassName("footerList")[0].style.bottom = "0";
                } else {
                    document.getElementsByClassName("footerList")[0].style.bottom = "44px";
                }
            } else {
                if(isApp) {
                    document.getElementsByClassName("footerList")[0].style.bottom = "-70px";
                } else {
                    document.getElementsByClassName("footerList")[0].style.bottom = "-26px";
                }
            }
            prevScrollpos = currentScrollPos;
        }
    }
    
    return (
        <div>
            <div className="disclaimer-con">
                <div className="disclaim left R13_9e" onClick={() => { actions.disclClick(flag) }}>Disclamer</div>
                <div className="feedback left R13_9e" onClick={() => { actions.feedbClick(flag) }}>Feedback</div>
            </div>
            {flag == "RDL" &&
                <div className="askqueexpert" onClick={() => { eleRef.AskQnaQuetion() }}>
                    <span className="M14_FF dev_ask_queexprt"> Ask Question With Our Experts Now!</span>
                </div>
            }
            <div className="footerList">
                <div className={flag == "ML" ? "flist-block left Meal selected-flist" : "flist-block left Meal"} onClick={(e) => actions.listingMenu(e, "Meal", flag,"", isApp)}>
                    <div className="flist-img ">
                        {/* <span data-icon-font="q" className="flisticon"></span> */}
                        {flag == "ML" ?
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Group_s.png" className="flisticon" data-title="Meal Planner" alt="Group Icon" title="Group Icon" />
                            :
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Group.png" className="flisticon" data-title="Meal Planner" />
                        }
                    </div>
                    <div className="flist-title M12_pink" data-title="Meal Planner">Meal Planner</div>
                </div>
                <div className={flag == "RL" || flag == "RDL" ? "flist-block left Recipes selected-flist" : "flist-block left Recipes"} onClick={(e) => actions.listingMenu(e, "Recipes", flag, recipes, isApp)}>
                    <div className="flist-img">
                        {/* <span data-icon-font="q" className="flisticon"></span> */}
                        {flag == "RL" || flag == "RDL" ?
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/chef_s.png" alt="Chef Icon" title="Chef Icon" className="flisticon" data-title="Recipes" />
                            :
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/chef.png" alt="Chef Icon" title="Chef Icon" className="flisticon" data-title="Recipes" />
                        }
                    </div>
                    <div className="flist-title M13_9e" data-title="Recipes">Recipes</div>
                </div>
                <div className={flag == "GL" ? "flist-block left Grocery selected-flist" : "flist-block left Grocery"} onClick={(e) => actions.listingMenu(e, "Grocery", flag,"", isApp)}>
                    <div className="flist-img">
                        {/* <span data-icon-font="q" className="flisticon"></span> */}
                        {flag == "GL" ?
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Layer_s.png" className="flisticon" data-title="Grocery List" />
                            :
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Layer.png" className="flisticon" data-title="Grocery List" alt="Layer Icon" title="Layer Icon" />
                        }
                    </div>
                    <div className="flist-title M13_9e" data-title="Grocery List">Grocery List</div>
                </div>
                <div className={flag == "BM" ? "flist-block left Bookmark selected-flist" : "flist-block left Bookmark"} onClick={(e) => actions.listingMenu(e, "Bookmark", flag, "", isApp)}>
                    <div className="flist-img">
                        {/* <span data-icon-font="q" className="flisticon"></span> */}
                        {flag == "BM" ?
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Forma_s.png" className="flisticon" data-title="Bookmark" />
                            :
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Forma.png" alt="Bookmark" title="Bookmark" className="flisticon" data-title="Bookmark" />
                        }
                    </div>
                    <div className="flist-title M13_9e" data-title="Bookmark">Bookmark</div>
                </div>
            </div>
        </div >
    );
}
